// Constants
import { ResponsiveHeaderWidths } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { ElementIds } from "@ms/uno-constants/lib/local/UIConstants";
// Controls
import { Menu, MenuButton, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, Tooltip } from "@fluentui/react-components";
import { Assign } from "@ms/planner-generic-controls/lib/local/icons";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { useShareMenuButtonStyles } from "./ShareMenuButton.styles";
// Utilities
import * as React from "react";
import { useLoggers } from "../utilities/hooks/useLoggers";
/**
 * Share menu button component for plan header
 * @param props Share menu button props
 * @returns Share menu button component
 */ export const ShareMenuButton = ({ staticMenuItems, publishTemplateMenuItem, width })=>{
    const styles = useShareMenuButtonStyles();
    const { engagementLogger } = useLoggers();
    const [isMenuCalloutVisible, setIsMenuCalloutVisible] = React.useState(false);
    const shareButton = React.useRef(null);
    // Toggle menu callout visibility
    const toggleIsMenuCalloutVisible = ()=>{
        engagementLogger.logEngagement(EngagementTelemetryConstants.ShareMenuButton, EngagementTelemetryConstants.ShareButtonClicked);
        setIsMenuCalloutVisible(!isMenuCalloutVisible);
    };
    return /*#__PURE__*/ React.createElement(Menu, {
        open: isMenuCalloutVisible,
        onOpenChange: (e, data)=>{
            setIsMenuCalloutVisible(data.open);
        },
        positioning: {
            offset: 4
        }
    }, /*#__PURE__*/ React.createElement(MenuTrigger, {
        disableButtonEnhancement: true
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        content: Strings.PlanHeader_ShareMenuTooltip,
        relationship: "label"
    }, /*#__PURE__*/ React.createElement(MenuButton, {
        title: Strings.PlanHeader_ShareText,
        icon: /*#__PURE__*/ React.createElement(Assign, null),
        className: styles.shareButton,
        onClick: toggleIsMenuCalloutVisible,
        id: ElementIds.HeaderShareButton,
        appearance: "primary",
        ref: shareButton,
        "data-testid": "plan-header-share-button"
    }, width ? width >= ResponsiveHeaderWidths.maxWidth640 ? Strings.PlanHeader_ShareText : "" : Strings.PlanHeader_ShareText))), /*#__PURE__*/ React.createElement(MenuPopover, {
        className: styles.menuPopover,
        "data-testid": "plan-header-share-menu"
    }, /*#__PURE__*/ React.createElement(MenuList, null, staticMenuItems.map((menuItem)=>/*#__PURE__*/ React.createElement(MenuItem, {
            key: menuItem.key,
            className: styles.menuItem,
            onClick: ()=>menuItem.onClick(shareButton.current),
            icon: {
                children: menuItem.icon
            },
            "aria-label": menuItem.text,
            content: {
                className: styles.staticItemContent
            },
            disabled: menuItem.disabled,
            title: menuItem.title,
            "data-testid": menuItem.dataTestId
        }, /*#__PURE__*/ React.createElement("span", {
            className: styles.staticText
        }, menuItem.text))), publishTemplateMenuItem && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuDivider, {
        className: styles.menuBorder
    }), /*#__PURE__*/ React.createElement(MenuItem, {
        onClick: ()=>publishTemplateMenuItem.onClick(shareButton.current),
        icon: publishTemplateMenuItem.icon,
        "aria-label": publishTemplateMenuItem.text,
        content: {
            className: styles.staticItemContent
        },
        disabled: publishTemplateMenuItem.disabled,
        title: publishTemplateMenuItem.title,
        "data-testid": publishTemplateMenuItem.dataTestId
    }, publishTemplateMenuItem.text)))));
};
